// extracted by mini-css-extract-plugin
module.exports = {"container":"main-module--container--GjNtC","logoContainer":"main-module--logoContainer--2nM4j"};